import createAsyncActions from 'store/_utils/createAsyncActions';
import { TVesselsLocationsState } from './vesselsLocationsModel';

export enum EVesselsLocationsActions {
  FETCH_LOCATIONS = 'vesselsLocations/FETCH_LOCATIONS',
  START_WATCHING_LOCATIONS = 'vesselsLocations/START_WATCHING_LOCATIONS',
  STOP_WATCHING_LOCATIONS = 'vesselsLocations/STOP_WATCHING_LOCATIONS'
}

export const locationsSet = createAsyncActions<TVesselsLocationsState>(
  EVesselsLocationsActions.FETCH_LOCATIONS
);
